import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/blacksmith-ui/cn";

/** Clockwise from the top-left pin; the hover sweep in globals.css follows this order. */
const PINS = [{
  x: 8,
  y: 0,
  width: 2,
  height: 4
}, {
  x: 14,
  y: 0,
  width: 2,
  height: 4
}, {
  x: 20,
  y: 8,
  width: 4,
  height: 2
}, {
  x: 20,
  y: 14,
  width: 4,
  height: 2
}, {
  x: 14,
  y: 20,
  width: 2,
  height: 4
}, {
  x: 8,
  y: 20,
  width: 2,
  height: 4
}, {
  x: 0,
  y: 14,
  width: 4,
  height: 2
}, {
  x: 0,
  y: 8,
  width: 4,
  height: 2
}];
const PIN_SWEEP_STEP_MS = 70;

/**
 * Rail glyph for Sandboxes: a microVM chip on the same 24-cell, 2-cell-stroke
 * grid as `CodesmithIcon`. Hovering its rail row plays a boot sweep.
 */
export function SandboxesIcon(t0) {
  const $ = _c(7);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("sandboxes-chip shrink-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = PINS.map(_temp);
    t3 = <path d="M6 4h12v2H6zM6 18h12v2H6zM4 6h2v12H4zM18 6h2v12h-2z" />;
    t4 = <rect x={10} y={10} width={4} height={4} className="sandboxes-chip-core" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden={true} className={t1}>{t2}{t3}{t4}</svg>;
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function _temp(pin, index) {
  return <rect key={`${pin.x}-${pin.y}`} {...pin} className="sandboxes-chip-pin" style={{
    animationDelay: `${index * PIN_SWEEP_STEP_MS}ms`
  }} />;
}